import { mapGetters, mapState } from 'vuex'
import appointmentForm from './appointmentForm/appointmentForm.vue'
import AppointmentService from '../../../services/appointment/appointmentService'

export default {
    data() {
        return {
            activeStep: 0,
            sendingDelivery: false
        }
    },
    components: {
        appointmentForm
    },
    computed: {
        ...mapState('delivery', {
            patient: 'patient',
            provider: 'provider',
            orderDetails: 'orderDetails',
            selectedMedicines: 'selectedMedicines',
            state: 'state',
            city: 'city',
            schedule: 'schedule',
            scheduleName: 'scheduleName',
            //address: 'setBranchAddress',
            observations: 'observations',
            scheduleRange: 'scheduleRange',
            branchAddress: 'branchAddress',
            branchName: 'branchName'
        }),
        ...mapState('auth', [
            'user',
            'identification',
            'identificationType'
        ]),
        ...mapGetters('delivery', {
            slidingScaleFee: 'slidingScaleFee',
            shippingDate: 'shippingDate'
        })
    },
    methods: {
        nextStep() {
            this.activeStep += 1;
        },
        previousStep() {
            this.activeStep -= 1;
        },
        goHome() {
            this.$route.push('/home')
        },
        async sendAppointment() {
            this.sendingDelivery = true
            try {
                this.address = this.address === undefined ? "SIN_DIRECCION" : this.address
                this.nameNomenclature = this.nameNomenclature === undefined ? "" : this.nameNomenclature
                this.numberOne = this.numberOne === undefined ? "" : this.numberOne
                this.numberTwo = this.numberTwo === undefined ? "" : this.numberTwo
                this.numberThree = this.numberThree === undefined ? "" : this.numberThree

                const order = {
                    patients: [{
                        documentType: this.patient.identificationType,
                        document: this.patient.identification,
                        fullname: this.patient.name,
                        address: this.patient.address,
                        phoneNumber: this.phone,
                        mobilePhone: this.cellPhone
                    }],
                    orderData: {
                        status: 'SCHEDULED',
                        deliveryAddress: this.patient.address,
                        nameNomenclature: this.nameNomenclature,
                        numberOne: this.numberOne,
                        numberTwo: this.numberTwo,
                        numbreThree: this.numberThree,
                        minDate: this.minDate,
                        maxDate: this.maxDate,
                        orderType: this.provider == 1 ? 'INTEGRATED' : 'EXCLUSIVE',
                        deliveryDate: this.shippingDate,
                        providerId: this.provider,
                        notApplyShippingFee: this.shippingFee == 0 ? true : false,
                        orderDetail: this.getOrderDetails(this.orderDetails),
                        location: {
                            state: this.state,
                            city: this.city,
                            branch: this.branch,
                            scheduleRange: this.schedule
                        }
                    },
                    observation: this.observations
                }

                // console.log(order);
                await AppointmentService.saveAppointment(order)
                this.sendingDelivery = false
                this.nextStep()
            } catch (error) {
                const message = this.$t('app.components.delivery.an-error-ocurred-registering-delivery');
                this.$buefy.toast.open({ message, type: 'is-danger' })
                this.sendingDelivery = false
            }
        },
        getOrderDetails(orderDetails) {
            return orderDetails.map(orderDetail => {
                orderDetail.medicines = orderDetail.medicines.map(medicine => {
                    medicine.orderCode = medicine.orderDetailCode
                    medicine.count = medicine.quantity
                    return medicine
                })
                return orderDetail
            })
        },
    }
}